










































import { Mixins, Component, Prop, Watch } from "vue-property-decorator";
import { EditorItemMixin } from "./mixins";
import { ModelEditableMixin } from "../../../system/mixins";
import { DomainRegistry } from "../../../../domain";
import { Patient } from "../../../../domain/patient";
import { ReceptionPatient } from "../../../../domain/workflow/reception";

import { ReceptionDateTranslator } from "../../../../domain/workflow";
import { PatientViewerMixin } from "../../../patient/viewers/mixins";

import ReceptionPatientDialogSelector from "../../selectors/ReceptionPatientDialogSelector.vue";
import { HisInformationProcessResultConverter } from "../../../his/components/helper";

@Component({
  components: {
    ReceptionPatientDialogSelector,
  }
})
export default class ReceptionPatientEditor extends Mixins(
  PatientViewerMixin,
  EditorItemMixin,
  ModelEditableMixin
) {
  // ModelEditableMixinに実体あり
  editingSource: ReceptionPatient;

  @Prop()
  isSaved: boolean; // 保存済みか（一時保存、正式保存両方）

  @Prop()
  patientNo: string;

  data() {
    return {
      selectedPatient: null as Patient,
    };
  }
  selectedPatient: Patient;

  get patient(): Patient {
    return this.editingSource
      ? this.editingSource.patient
      : null;
  }

  get patientNote(): string {
    return this.editingSource.patientNote;
  }

  set patientNote(value: string) {
    this.writeProperty((c: ReceptionPatient) => (c.patientNote = value));
  }

  get patientNameText(): string {
    return this.patient ? this.name + " ( " + this.kanaName + " )" : "";
  }

  created() {
    this._dateTranslator = new ReceptionDateTranslator();
  }
  _dateTranslator: ReceptionDateTranslator;

  mounted() {
    if (!!this.patient) {
      this.selectedPatient = this.patient;
    }
  }

  get birthAge(): string {
    return this.formatBirthdayString((b, a) => b + "(" + a + ")");
  }

  @Watch("selectedPatient")
  onSelectedPatientUpdated(newValue: Patient, oldValue: Patient) {
    if (!newValue) {
      this.editingSource = new ReceptionPatient();
      return;
    }
    this.getPatientInfo(newValue);
  }

  async getPatientInfo(patient: Patient): Promise<void> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      // this.isLoading = true;

      const patientInfo = await repository.getPatientInfo(patient.id);
      patientInfo.patient = patient;
      patientInfo.patientNoteBeforeEditing = patientInfo.patientNote;

      this.showHisInformationAlerts(patientInfo);

      this.editingSource = patientInfo;
      
      // this.isLoading = false;

    } catch (e) {
      // this.isLoading = false;
      this.$error("エラー", "患者情報の取得に失敗しました。", e);
    }
  }

  private showHisInformationAlerts(patientInfo: ReceptionPatient): void {
    try {
      if (!patientInfo.hisInformation) {
      // 現状ではHIS情報取得失敗しているときはここに到達しないが念のため
        this.$info("患者情報取得" , "患者情報を取得できませんでした。");
        return;
      }
      // TODO: できれば使っていない情報の通知は出したくない
      const message = HisInformationProcessResultConverter.toMessageText(patientInfo.hisInformation.processResult);
      if (!message) { return; }
      this.$info("患者情報取得" , message);
    } catch (e) {
      // エラーは起こさないようにしているが念のため
      this.$logger.error("情報取得失敗の通知処理中にエラーが発生しました。");
      this.$logger.error(e);
    }
  }
}
